import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHammer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHammer"><Path d="M0.335938 11.25L9.58592 2H14.9144L17.9143 4.99996L6.00013 16.9142L0.335938 11.25Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M18.9093 22.091L11.1593 14.341L14.3412 11.159L22.0912 18.909L18.9093 22.091Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHammer;
